// extracted by mini-css-extract-plugin
export var infoRow = "_v3-2";
export var labelContainer = "_v3-0";
export var rightInfo = "_v3-1";